module.exports = __webpack_public_path__ + "static/media/hexagons.da2c96b6.svg";